export const charterSections = [
	{
		id: 'who-we-are',
		label: 'Who We Are',
	},
	{
		id: 'core-values',
		label: 'Core Values',
	},
	{
		id: 'joining',
		label: 'Interested in Joining?',
	},
	{
		id: 'charter',
		label: 'Charter',
		children: [
			{
				id: 'what-we-do',
				label: 'What We Do',
			},
			{
				id: 'rules',
				label: 'Rules',
			},
			{
				id: 'anti-cheating-policy',
				label: 'Anti-Cheating Policy',
			},
			{
				id: 'communication-policy',
				label: 'Communication Policy',
				children: [
					{
						id: 'discord-rules',
						label: 'Discord Rules',
					},
				],
			},
		],
	},
	{
		id: 'aion-online-charter',
		label: 'Aion Online Charter',
		children: [
			{
				id: 'invitation-policy',
				label: 'Invitation Policy',
				children: [
					{
						id: 'recruitment-paths',
						label: 'Recruitment Paths',
					},
					{
						id: 'vouching-system',
						label: 'Vouching System',
					},
					{
						id: 'objections',
						label: 'Objections',
					},
					{
						id: 'alt-characters',
						label: 'Alt Characters',
					},
					{
						id: 'inactivity-policy',
						label: 'Inactivity Policy',
					},
					{
						id: 'leaving-the-legion',
						label: 'Leaving the Legion',
					},
					{
						id: 'ranking-system',
						label: 'Ranking System',
					},
					{
						id: 'recruitment-summary',
						label: 'Recruitment Summary',
					},
				],
			},
			{
				id: 'grouping-statics',
				label: 'Grouping & Statics Policy',
			},
			{
				id: 'loot-distribution',
				label: 'Loot Distribution',
				children: [
					{
						id: 'groups-and-statics',
						label: 'Groups and Statics',
					},
					{
						id: 'raids-and-world-bosses',
						label: 'Raids and World Bosses',
					},
					{
						id: 'platform-bosses',
						label: 'Platform Bosses',
					},
				],
			},
			{
				id: 'dkp-system',
				label: 'DKP System',
				children: [
					{
						id: 'dragon-kill-points',
						label: 'Dragon Kill Points',
					},
					{
						id: 'purchasing-items',
						label: 'Purchasing Items',
					},
				],
			},
			{
				id: 'definitions',
				label: 'Definitions',
			},
		],
	},
] as const
